import ProductHorizontalList from './ProductHorizontalList'

export default ProductHorizontalList
